<div class="toast-container">
    <div class="toast-header-section">
        <div class="toast-icon" [ngClass]="{'toast-icon-warn': data?.type === 'warning', 'toast-icon-success' : data?.type === 'success', 'toast-icon-fail' : data?.type === 'error'}" [innerHTML]="toastIcon | safeHtml"></div>
        <span class="toast-heading">{{data.heading}}</span>
        <!-- <div class="cross-btn" *ngIf="showCloseIcon">
            <button mat-button>
                <div [innerHTML]="closeIcon | safeHtml"></div>
            </button>
        </div> -->
    </div>
    <div class="content-section">
       {{content}}
    </div>
    <div class="button-section">
        <ng-container *ngFor="let button of data?.showButtons">
            <ng-container *ngIf="button.type === 'submit'">
                <button (click)="actionHandler(button, data)" mat-button
                    class="pointer color-primary-teal-500 fw-700 signup-link d-inline-block">{{button.label}}</button>
            </ng-container>
            <ng-container *ngIf="button.type === 'cancel'">
                <button (click)="actionHandler(button, data)" mat-stroked-button
                    [ngClass]="button.class">{{button.label}}</button>
            </ng-container>
        </ng-container>
    </div>

    <mat-progress-bar *ngIf="data?.showProgressBar" mode="indeterminate"></mat-progress-bar>

</div>